export const SENDERS = {
  login: 'verify@auth.basehub.com',
  notifications: 'hey@notifications.basehub.com', // subdomain for notications
}
